import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/spring-rv-expo")({
  head: () => pageHead({ title: 'Spring RV Expo', description: 'Join Rex & Sons RVs for our Spring RV Expo — special pricing, new models and family fun.', path: '/spring-rv-expo' }),
  beforeLoad: () => {
    throw redirect({ href: "/p/spring-rv-show-expo" });
  },
});
